import { t } from '@lingui/macro'
import React, { useEffect, useState } from 'react'
import { SuggestionDataItem } from 'react-mentions'
import { Message } from '../../models/Message'
import { UtilApp } from '../../services/Utils/UtilApp'
import MentionTextArea from './MentionTextArea'

export const userMarkup = '[__display__](user:__id__)'

interface IMentionTextArea {
  message: Message,
  suggestions: SuggestionDataItem[],
  onChange: (text: string) => void,
  onSubmit: ((text: string) => void)
}
const MessageTextArea: React.FC<IMentionTextArea> = ({ message, suggestions, onChange, onSubmit }) => {
  const [text, setText] = useState("");
  const [placeholder, setPlaceholder] = useState("")

  useEffect(() => {
    setText(message.text ?? "");
    if (message.replyTo) {
      setPlaceholder(t`Reply to ${message.replyTo.name}.`);
    } else {
      setPlaceholder(t`Mention with '@'` + (UtilApp.isMobileSize() ? '' : t`. Send with ctrl+enter.`))
    }
  }, [message.id, message.replyTo?.id]);

  function changed(value: string) {
    onChange(value);
    setText(value);
    message.text = value;
  }

  return (<MentionTextArea text={text} placeholder={placeholder} suggestions={suggestions} onChange={changed} onSubmit={onSubmit} />);
}

export default MessageTextArea;
